import {
  CreateShareRequest,
  CreateShareResponse,
  ListSharesResponse,
  ShareResourceTypeApi,
  ShareDto,
} from 'src/types/share';
import { baseAPICreator } from './apiCreator';

const shareApi = baseAPICreator('/share');

export const createShares = async (
  body: CreateShareRequest
): Promise<CreateShareResponse> => {
  const { data } = await shareApi.post<CreateShareResponse>('', body);
  return data;
};

export const listResourceShares = async (
  resourceType: ShareResourceTypeApi,
  resourceId: string
): Promise<ListSharesResponse> => {
  const { data } = await shareApi.get<ListSharesResponse>('', {
    params: { resourceType, resourceId },
  });
  return data;
};

export const listReceivedShares = async (): Promise<ShareDto[]> => {
  const { data } = await shareApi.get('/received');
  if (Array.isArray(data)) {
    return data;
  }
  if (Array.isArray(data?.shares)) {
    return data.shares;
  }
  return [];
};

export const revokeShare = async (
  shareId: string
): Promise<{ success: boolean }> => {
  const { data } = await shareApi.delete(`/${shareId}`);
  return data;
};

export const leaveShare = async (
  shareId: string
): Promise<{ success: boolean }> => {
  const { data } = await shareApi.delete(`/${shareId}/leave`);
  return data;
};
